<app-navbar></app-navbar>

<div class="dashboard-full-width">
  <div class="">
    <div class="main-container-dashboard">
      <!-- <app-ministry-sidebar></app-ministry-sidebar> -->

      <div class="dashboard-container-right">
        <div class="main-container">
          <div class="row">
            <div class="card shadow m-3" style="width: 100%">
              <div
                class="
                  card-header
                  heading_n_button_box
                  card-header-cus-new-appoint card-header-responsive
                "
              >
                <div class="card-heading">
                  <h4>Verify with Appointment ID</h4>
                </div>

                <div class="button-section mt-1"></div>
              </div>

              <div class="card-body p-5">
                <form
                  [formGroup]="uniqueForm"
                  (ngSubmit)="submitForm(uniqueForm.value)"
                >
                  <div class="messages"></div>
                  <div class="controls">
                    <div class="row">
                      <div class="col-lg-4">
                        <div class="form-group">
                          <label>Enter Appointment ID </label>
                          <input
                            type="text"
                            formControlName="uniqueId"
                            class="form-control login_input_padding"
                            maxlength="11"
                            name="uniqueId"
                            [ngClass]="{ 'is-invalid': submitted &amp;&amp; uniqueForm.controls.uniqueId.errors }"
                            placeholder="Appointment ID"
                          />
                          <div
                            *ngIf="submitted &amp;&amp; uniqueForm.controls.uniqueId.errors"
                            class="form-text text-danger"
                          >
                            <div
                              *ngIf="
                                uniqueForm.controls.uniqueId.errors.minlength
                              "
                            >
                              A minimum of 11 characters is required
                            </div>
                            <div
                              *ngIf="
                                uniqueForm.controls.uniqueId.errors.pattern
                              "
                            >
                              Please enter a valid Appointment ID
                            </div>
                            <div
                              *ngIf="
                                uniqueForm.controls.uniqueId.errors.required
                              "
                            >
                              Appointment ID is required
                            </div>
                          </div>

                          <!-- <div class="help-block with-errors"></div> -->
                        </div>
                      </div>

                      <div class="col-lg-2">
                        <div class="form-group text-center mt-4">
                          <button
                            type="submit"
                            class="theme_btn tp_two logo-button-website"
                          >
                            Verify
                          </button>
                          <button
                            type="button"
                            (click)="viewModal(resultModal)"
                            id="loadModal"
                            class="d-none"
                          ></button>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template let-modal #resultModal>
  <!-- Modal -->
  <div class="">
    <div class="m">
      <div class="modal-content">
        <div
          class="modal-header-custom card-header"
          style="display: block; text-align: center"
        >
          <!-- <h5 class="modal-title" id="exampleModalLongTitle">Update Record</h5> -->

          <h3 style="margin-bottom: 0px; font-size: 18px">COVID-19 Result</h3>
        </div>

        <div class="">
          <div class="container-fluid">
            <div class="row">
              <div class="col-lg-7 partition-1">
                <div class="mt-4">
                  <h5 class="text-bold">Status:</h5>
                  <span
                    *ngIf="testDetails.test_result == 'Positive' || testDetails.test_result == 'POSITIVE'"
                    class="text-danger text-bold"
                  >
                    {{ testDetails.test_result | uppercase}}
                  </span>
                  <span
                    *ngIf="testDetails.test_result == 'NEGATIVE' || testDetails.test_result == 'Negative'"
                    class="text-success text-bold"
                  >
                    {{ testDetails.test_result | uppercase}}
                  </span>
                </div>

                <div class="mt-4">
                  <h5 class="text-bold">Flight Details:</h5>

                  For flight to
                  {{
                    testDetails?.type == "2"
                      ? testDetails?.arrival_country
                      : testDetails?.departure_country
                  }}
                </div>

                <div>Valid Till: {{ testDetails?.validity_date | date }}</div>

                <div>Sample Collection date: {{ testDetails?.test_date }}</div>

                <div class="passenger-box mt-4">
                  <h5 class="text-bold">Passenger Details:</h5>
                  <tr class="pl-5">
                    <td>
                      <strong>
                        Passenger's Name: <br />
                        Passport Number: <br />
                        Laboratory Name: <br />
                        Date of Birth: <br />
                        Status: <br />
                      </strong>
                    </td>

                    <td colspan="4" class="ml-5 pl-5">
                      <strong>
                        {{
                          testDetails?.first_name +
                            " " +
                            testDetails?.middle_name +
                            " " +
                            testDetails?.last_name
                        }}<br />
                        {{ testDetails?.passport_no }} <br />
                        {{ testDetails?.lab_name }} <br />
                        {{ testDetails?.dob }} <br />
                        {{ status }} <br />
                      </strong>
                    </td>
                  </tr>
                </div>
              </div>

              <div class="col-lg-5 position-relative">
                <img class="or-img" src="assets/image/icon/or.png" />

                <div class="qr-box">
                  <img src="{{ testDetails?.qrcode_filepath }}" />
                </div>

                <div class="box-qr-info">
                  You are requested to scan the given QR code to fetch the
                  information. 
                  <p *ngIf="testDetails.test_result == 'Positive' || testDetails.test_result == 'POSITIVE'"><a target="_blank" href="assets/image/positive.png">Click Here for Mobile Report</a></p>
                  <p *ngIf="testDetails.test_result == 'NEGATIVE' || testDetails.test_result == 'Negative'"><a target="_blank" href="assets/image/NEGATIVE.png">Click Here for Mobile Report</a></p>
                </div>
              </div>
            </div>

            <!-- <div class="col-md-12 justify-content-end d-flex d-none">
              <button class=" theme_btn tp_two logo-button-website">Print <i class="fas fa-print"></i></button>
            </div> -->
          </div>

          <div class="border-bottom-inbound"></div>
          <div class="container-fluid font-12">
            <div class="text-center mt-3 mb-3">
              <div class="">
                <!-- This is comments due to Rama suggestion for EG preventing frud -->
                <!-- <button
                  class="theme_btn tp_two logo-button-website"
                  (click)="confirmResult(testDetails?.id, 'AUTHENTIC')"
                >
                  Authentic
                </button>
                <button
                  class="theme_btn tp_two logo-button-website ml-3"
                  (click)="confirmResult(testDetails?.id, 'FORGED')"
                >
                  Forged
                </button> -->

                <button
                  type="button"
                  class="theme_btn tp_two logo-button-website ml-3"
                  id="closeModal"
                  (click)="modal.close('Save click')"
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template let-modal #invalidModal>
  <!-- Modal -->
  <div class="bg-danger">
    <div class="m">
      <div class="modal-content">
        <div class="modal-header-custom">
          <!-- <h5 class="modal-title" id="exampleModalLongTitle">Update Record</h5> -->
          <button
            type="button"
            class="float-right"
            (click)="modal.close('Save click')"
          >
            <i class="fas fa-times-circle"></i>
          </button>
        </div>
        <div class="bg-danger">
          <div class="container-fluid">
            <div class="container-fluid font-13">
              <div class="text-center mt-3 mb-3">
                <b>Action : This result is</b><br />
                <div class="">
                  <button
                    class="theme_btn tp_two logo-button-website"
                    (click)="confirmResult(testDetails?.id, 'AUTHENTIC')"
                  >
                    Authentic
                  </button>
                  <button
                    class="theme_btn tp_two logo-button-website ml-3"
                    (click)="confirmResult(testDetails?.id, 'FORGED')"
                  >
                    Forged
                  </button>
                </div>
                <br />
                <div>
                  <button
                    class="scan-button"
                    type="button"
                    (click)="modal.close('Save click')"
                  >
                    Scan Next Result
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
